import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Radio,
  Select,
  Switch,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Booking from "../api/booking";
import Machine from "../api/machine";
import Colors from "../constants/colors.json";
import Language from "../constants/language_fr.json";
import Styles from "../constants/styles.json";
import ActivityIndicatorContext from "../Contexts/ActivityIndicatorContext";
import LokaActivityIndicator from "./LokaActivityIndicator";
import LokaDatePicker from "./LokaDatePicker";
import InputLabel from "@mui/material/InputLabel";
import { getDiscountList, getDiscountPrices } from "../globals";
import MachineApi from "../api/machine";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import SearchIcon from "@mui/icons-material/Search";
import MultipleDesignationInput from "./MultipleDesignationInput";
import { useSelector } from "react-redux";
import { getCustomers } from "../api/api-tk";
import PersonIcon from "@mui/icons-material/Person";

const AddBooking = ({
  discountGrid = [],
  handleClose,
  handleMergeBooking,
  initialBooking,
  role,
  setSnackBar,
}) => {
  const { setActivityIndicator } = useContext(ActivityIndicatorContext);
  const { company, members, user } = useSelector(({ slice }) => slice.value);
  const [booking, setBooking] = useState(initialBooking);
  const [discount, setDiscount] = useState({
    ...initialBooking?.rentalPrices?.discountList?.[0],
  });
  const [isCustomerSearchOpen, setIsCustomerSearchOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const {
    checker,
    createdAt,
    createdBy,
    delivery,
    departureAgency = "",
    equipmentsSelected,
    id: idBooking,
    machine,
    rentalPrices,
    state,
    servicesSelected,
  } = booking || {};

  const { availableRangeDates } = machine || {};
  const [availableEndDate] = availableRangeDates?.availableEndDate || [];
  const [availableStartDate] = availableRangeDates?.availableStartDate || [];

  const { benefits, equipments, rentMode } = machine || {};

  const [localProps, setlocalProps] = useState({ loading: true });

  const constructor = async () => {
    const { ConfigBooking, GetAllContracts } = Booking || {};
    const { rentMode = {} } = await MachineApi.Config({
      category: initialBooking?.machine?.machine?.category,
      token: user?.token,
    });
    const { ConfigKeyLabelConverter } = Machine || {};
    const { customer } = await ConfigBooking({
      token: user.token,
    });
    const _contracts = await GetAllContracts({
      idMachine: initialBooking?.machine?.id,
      token: user.token,
    });
    const response = await ConfigKeyLabelConverter({
      category: initialBooking?.machine?.machine?.category,
      token: user.token,
    });

    setBooking(initialBooking);
    setlocalProps({
      bookingConfig: { customerConfig: customer },
      contracts: _contracts,
      keyLabelConverter: response,
      loading: false,
      machineUnity: rentMode.machineUnity,
    });
  };

  const handleGetCustomers = async () => {
    const suggestedCustomers =
      booking?.customer?.name?.length > 2
        ? await getCustomers({
            name: booking?.customer?.name,
            token: user.token,
          })
        : [];
    setlocalProps((_localProps) => ({ ..._localProps, suggestedCustomers }));
  };

  const {
    bookingConfig,
    contracts,
    keyLabelConverter,
    loading,
    machineUnity,
    suggestedCustomers,
  } = localProps || {};

  const { agencies: cieAgencies = [], subCompanies = [] } = company;

  useEffect(() => {
    constructor();
  }, []);

  const { customerConfig } = bookingConfig || {};

  const _excludeDates = contracts?.length
    ? contracts
        .filter(
          (contract) =>
            !(role === "updateBooking" && contract.id === initialBooking.id),
        )
        .map((contract) => contract?.rentalPeriod || [])
        .flat()
    : [];

  const _rentMode =
    keyLabelConverter && rentMode
      ? ["dayPrice", "monthPrice", "unityPrice", "surfacePrice"].map((key) => {
          return {
            key,
            label: keyLabelConverter[key],
            value: rentMode?.[key],
            isDisabled: rentMode?.[key] ? false : true,
          };
        })
      : [];

  const _servicesSelected =
    keyLabelConverter && benefits
      ? Object.entries(benefits).map(([key, value]) => {
          return {
            key,
            label: keyLabelConverter[key],
            value,
            sigle: `€`,
          };
        })
      : [];

  const _equipmentsSelected =
    keyLabelConverter && equipments
      ? Object.entries(equipments).map(([key, value]) => {
          return {
            key,
            label: keyLabelConverter[key],
            value: value[rentalPrices.key],
            sigle: `€ ${Language.addBooking[rentalPrices.key]}`,
          };
        })
      : [];

  const handleChangeDate = (rentalPeriod) => {
    const { key } = rentalPrices;
    const isDayMode = key === "dayPrice";
    const _quantity = String((rentalPeriod || []).length);
    isDayMode
      ? setBooking({
          ...booking,
          rentalPrices: { ...rentalPrices, quantity: _quantity },
          rentalPeriod,
        })
      : setBooking({ ...booking, rentalPeriod });
  };

  const handleCreateUpdateBooking = async () => {
    const { Create, Update } = Booking || {};
    setActivityIndicator({
      isOpen: true,
      message:
        role === "addBooking"
          ? Language.addBooking.addBookingInProgress
          : Language.addBooking.updateBookingInProgress,
    });
    const _bookingToUpdate = {
      ...booking,
      createdAt,
      createdBy,
      id: idBooking,
    };
    if (role === "addBooking") {
      const status = await Create({
        booking,
        token: user.token,
      });
      if (status === 200) {
        handleResetClose();
        setSnackBar({
          isOpen: true,
          message: Language.addBooking.addBookingSuccess,
          status: "success",
        });
        setActivityIndicator({ isOpen: false, message: null });
      } else {
        setActivityIndicator({ isOpen: false, message: null });
      }
    } else if (role === "updateBooking") {
      const { data, status } = await Update({
        booking: _bookingToUpdate,
        token: user.token,
      });
      if (status === 200) {
        const { booking } = data || {};
        handleMergeBooking({ booking });
        handleResetClose();
        setSnackBar({
          isOpen: true,
          message: Language.addBooking.updateBookingSuccess,
          status: "success",
        });
        setActivityIndicator({ isOpen: false, message: null });
      } else {
        setActivityIndicator({ isOpen: false, message: null });
      }
    }
  };

  const handleConvertInContract = () => {
    const hasExcludeDate = booking.rentalPeriod.filter((date) =>
      _excludeDates?.includes(date),
    );
    hasExcludeDate?.length &&
      setSnackBar({
        isOpen: true,
        message: `Les dates suivantes ne sont plus disponibles : ${hasExcludeDate?.join(
          ", ",
        )}`,
        status: "error",
      });

    setBooking((booking) => ({
      ...booking,
      rentalPeriod: booking.rentalPeriod.filter(
        (date) => !_excludeDates?.includes(date),
      ),
      state: "contract",
    }));
  };

  const handleInputChange = ({ bookingKey, target, key }) => {
    const _booking = bookingKey
      ? {
          ...booking,
          [bookingKey]: {
            ...booking[bookingKey],
            [key]: target?.value,
          },
        }
      : {
          ...booking,
          [key]: target?.value,
        };
    key && setBooking(_booking);
  };

  const handleRentModeChange = ({ key }) => {
    const _discountList = getDiscountList({
      contractType: "standard",
      discountGrid,
      rentalPricesKey: key,
    });
    const _booking = {
      ...booking,
      rentalPrices: {
        contractType: "standard",
        discountList: _discountList,
        key,
        [key]: rentMode[key],
        quantity:
          key === "dayPrice" ? String(booking.rentalPeriod.length) : "0",
      },
    };
    setBooking(_booking);
  };

  const handleChangeContractType = ({ target }) => {
    const { value } = target || {};
    const _discountList = getDiscountList({
      contractType: value,
      discountGrid,
      rentalPricesKey: booking?.rentalPrices?.key,
    });
    const { defaultStage } =
      discountGrid?.find(({ key }) => key === value) || {};

    const _stage = defaultStage ? { stage: defaultStage } : {};
    const _booking = {
      ...booking,
      ..._stage,
      rentalPrices: {
        ...booking?.rentalPrices,
        contractType: value,
        discountList: _discountList,
      },
    };
    setBooking(_booking);
  };
  const handleSelectChange = ({ key, value }) => {
    const _booking = {
      ...booking,
      [key]: value,
    };
    setBooking(_booking);
  };
  const handleSelectCustomer = ({ ...customer }) => {
    setBooking((_booking) => ({
      ..._booking,
      customer: { ...customer, owner: customer?.interlocutor || "" },
    }));
    setIsCustomerSearchOpen(false);
  };

  const handleSetSubCompany = ({ cieName }) => {
    const _subCompany = subCompanies.find((subCie) => cieName === subCie?.name);
    setBooking((booking) => ({ ...booking, subCompany: _subCompany }));
  };

  const handleResetClose = () => {
    handleClose();
  };

  const handleSetDiscount = () => {
    const hasDiscountValue = parseFloat(discount?.value) > 0;
    const { discountList, ...rest } = booking?.rentalPrices || {};
    setBooking({
      ...booking,
      rentalPrices: hasDiscountValue
        ? {
            ...booking?.rentalPrices,
            discountList: [discount],
          }
        : { ...rest },
    });
    handleCloseDiscount();
  };

  const handleCloseDiscount = () => {
    setDiscount({ key: "", value: "", discountComment: "" });
    setIsEditMode(false);
  };

  const handleSwitchOnEditMode = () => {
    const _discount = booking?.rentalPrices?.discountList?.[0] || {};
    const handleOpenDiscountModal = () => {
      setDiscount(_discount);
      setIsEditMode(true);
    };
    parseFloat(grossAmount) > 0
      ? handleOpenDiscountModal()
      : setSnackBar({
          isOpen: true,
          message: Language.addBooking.noGrossAmount,
          status: "error",
        });
  };

  const handleSwitchDiscountChange = ({ key }) => {
    return key
      ? setBooking({
          ...booking,
          rentalPrices: {
            ...booking?.rentalPrices,
            contractType: key,
          },
        })
      : null;
  };
  const handleSwitchServicesChange = ({ group, key, value }) => {
    const onChecking = booking[group][key] ? false : true;
    const _booking = onChecking
      ? { ...booking, [group]: { ...booking[group], [key]: value } }
      : { ...booking, [group]: { ...booking[group], [key]: false } };
    setBooking(_booking);
  };

  const handleSwitchEquipmentsChange = ({ group, key, value }) => {
    const onChecking = booking?.[group]?.[key] ? false : true;
    const _booking = onChecking
      ? {
          ...booking,
          [group]: { ...(booking?.[group] || {}), [key]: equipments?.[key] },
        }
      : { ...booking, [group]: { ...(booking?.[group] || {}), [key]: false } };
    setBooking(_booking);
  };

  const Summary = () => {
    const { machine, machineFeatures } = booking.machine || {};
    const { agency, bondPrice, brand, category, model, valuePrice, year } =
      machine || {};
    const { horsePower } = machineFeatures || {};
    const { distance, key: deliveryKey, kmPrice, totalAmount } = delivery || {};
    const _customerSummary = [
      "name",
      "owner",
      "address",
      "city",
      "phone",
      "email",
    ]
      .map((item) =>
        booking?.customer && booking?.customer[item]
          ? booking?.customer[item]
          : null,
      )
      .filter((el) => el);

    const _machineSummary = [
      {
        key: "description",
        value: `${Language.categoryConverter[category]} ${brand} ${model}`,
      },
      { key: "agency", title: Language.addBooking.agency, value: agency },
      { key: "year", title: Language.addBooking.year, value: year },
      {
        key: "horsePower",
        title: Language.addBooking.horsePower,
        value: horsePower,
        sigle: "ch",
      },
      {
        key: "bondPrice",
        title: Language.addBooking.bondPrice,
        value: bondPrice,
        sigle: "€",
      },
      {
        key: "valuePrice",
        title: Language.addBooking.valuePrice,
        value: valuePrice,
        sigle: "€",
      },
    ];

    const _rentalPricesLabel = {
      key: "rentalPricesLabel",
      value: `${rentalPrices.quantity || "0"} ${
        Language.rentalPrices[rentalPrices.key]
      } x ${rentalPrices[rentalPrices.key]}€ = ${String(
        parseFloat(rentalPrices[rentalPrices.key]).toFixed(2) *
          parseFloat(rentalPrices.quantity).toFixed(2),
      )}€`,
    };

    const _deliveryLabels = {
      agencyPickUp: {
        key: "agencyPickUp",
        value: `${Language.addBooking.agencyPickUp}: ${agency}`,
      },
      toDeliver: {
        key: "toDeliver",
        value: `${Language.addBooking.toDeliver}: ${distance}${Language.addBooking.kms} x ${kmPrice}${Language.addBooking.eurosPerKm} = ${totalAmount}€`,
      },
      toDeliverRoundTrip: {
        key: "toDeliverRoundTrip",
        value: `${Language.addBooking.toDeliverRoundTrip}: ${distance}${Language.addBooking.kms} x ${kmPrice}${Language.addBooking.eurosPerKm} = ${totalAmount}€`,
      },
    };

    const _servicesLabels = Object.entries(servicesSelected)
      ?.map(([key, value]) => {
        return value
          ? { key, value: `${keyLabelConverter[key]} = ${value}€` }
          : null;
      })
      .filter((service) => service);

    const _equipmentsSelectedLabels = Object.entries(equipmentsSelected)
      .map(([key, value]) => {
        return value
          ? {
              key: key,
              value: `${keyLabelConverter[key]} : ${rentalPrices?.quantity} ${
                Language.rentalPrices[rentalPrices.key]
              } x ${value[rentalPrices?.key]}€`,
            }
          : null;
      })
      .filter((equipment) => equipment);

    const _totalRentalPrices =
      parseFloat(rentalPrices.quantity || "0") *
      parseFloat(rentalPrices[rentalPrices.key] || "0");

    const _totalDelivery = delivery?.totalAmount
      ? parseFloat(delivery.totalAmount)
      : 0;

    const getTotalServices = () => {
      const _totalServices = Object.values(servicesSelected).filter(
        (service) => service,
      );

      return _totalServices.length
        ? _totalServices
            .filter((service) => service)
            .reduce((value, acc) => parseFloat(value) + parseFloat(acc), 0)
        : 0;
    };

    const getTotalEquipments = () => {
      const _totalEquipments = Object.values(equipmentsSelected).filter(
        (equipment) => equipment,
      );
      return _totalEquipments.length
        ? _totalEquipments
            .map((value) =>
              value
                ? parseFloat(rentalPrices.quantity) *
                  parseFloat(value[rentalPrices.key])
                : null,
            )
            .reduce((curr, acc) =>
              (parseFloat(curr) + parseFloat(acc)).toFixed(2),
            )
        : 0;
    };

    const _total = [
      _totalRentalPrices,
      _totalDelivery,
      getTotalServices(),
      getTotalEquipments(),
    ].reduce((curr, acc) => (parseFloat(curr) + parseFloat(acc)).toFixed(2));

    return (
      <>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          sx={Styles.bottomSeparator}
        >
          <Box flex={1}>
            {_customerSummary.map((item) => (
              <Typography key={item}>{item || ""}</Typography>
            ))}
          </Box>
          <Box flex={1}>
            {[_rentalPricesLabel, _deliveryLabels[deliveryKey]].map((item) => (
              <Typography key={item.key}>{item.value}</Typography>
            ))}
            {_servicesLabels.map((item) => (
              <Typography key={item.key}>{item.value}</Typography>
            ))}
            {_equipmentsSelectedLabels.map((item) => (
              <Typography key={item.key}>{item.value}</Typography>
            ))}
            <Typography
              sx={{
                borderTopStyle: "solid",
                borderTopWidth: 1,
                borderTopColor: Colors.greyHighShaded,
                marginTop: 1,
                paddingTop: 1,
                fontWeight: "bold",
              }}
            >{`${Language.addBooking.total}: ${String(
              _total,
            )}€ H.T`}</Typography>
          </Box>
        </Box>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          sx={{
            padding: 4,
          }}
        >
          <Box flex={1}>
            {_machineSummary.map(
              (item) =>
                item?.value && (
                  <Box display="flex" flexDirection="row" key={item.key}>
                    {item?.title ? (
                      <Typography
                        marginRight={1}
                      >{`${item?.title} : `}</Typography>
                    ) : null}
                    <Typography fontWeight="bold">{`${item.value}${
                      item?.sigle || ""
                    }`}</Typography>
                  </Box>
                ),
            )}
          </Box>
          <Box flex={1}>
            <LokaDatePicker
              isEditable={false}
              rentalPeriod={booking.rentalPeriod}
            />
          </Box>
        </Box>
      </>
    );
  };

  const steps = [
    {
      helpers: "1. Mode de réservation",
      key: "rentalPrices",
      name: "Mode de location",
      type: "rentalPrices",
    },
    {
      helpers: "2. Planning de réservation",
      key: "rentalPeriod",
      name: "Dates",
      type: "calendar",
    },
    {
      helpers: "3. Coordonnées de votre client",
      key: "customer",
      name: "Client",
      inputsList: customerConfig?.items,
      type: "text",
    },
    {
      helpers: "4. Equipements réservés",
      key: "equipmentsSelected",
      name: "Equipements",
      inputsList: _equipmentsSelected,
      type: "switchEquipments",
    },
    {
      helpers: "5. Services réservés",
      key: "servicesSelected",
      name: "Services",
      inputsList: _servicesSelected,
      type: "switchServices",
    },
    {
      helpers: "6. Suppléments",
      key: "bookingCosts",
      name: "Suppléments",
      type: "bookingCosts",
    },
    {
      helpers: "7. Commentaires",
      key: "comment",
      name: "Commentaires",
      type: "multiline",
    },
    {
      helpers: "8. Entité commerciale",
      key: "subCompany",
      name: "Entité commerciale",
      type: "subCompany",
    },
  ];

  const { key: discountKey, value: discountValue } =
    booking?.rentalPrices?.discountList?.[0] || {};

  const canSetDiscount = discountGrid?.some(
    ({ key, grid }) =>
      key === booking?.rentalPrices?.contractType &&
      Object.values(grid).some((el) => el),
  );

  const standardGrid = [
    {
      stdGridLabel: `Remise en ${machineUnity}(s)`,
      stdDisKey: "unity",
      stdDisValue: discount?.key === "unity" ? discount?.value : "",
      isMultiline: false,
      isAvailable: booking?.rentalPrices?.key === "unityPrice",
    },
    {
      stdGridLabel: `Remise en hectare(s)`,
      stdDisKey: "surface",
      stdDisValue: discount?.key === "surface" ? discount?.value : "",
      isMultiline: false,
      isAvailable: booking?.rentalPrices?.key === "surfacePrice",
    },
    {
      stdGridLabel: `Remise en jour(s)`,
      stdDisKey: "day",
      stdDisValue: discount?.key === "day" ? discount?.value : "",
      isMultiline: false,
      isAvailable: booking?.rentalPrices?.key === "dayPrice",
    },
    {
      stdGridLabel: `Remise en %`,
      stdDisKey: "percentage",
      stdDisValue: discount?.key === "percentage" ? discount?.value : "",
      isMultiline: false,
      isAvailable: true,
    },
    {
      stdGridLabel: `Remise en €`,
      stdDisKey: "default",
      stdDisValue: discount?.key === "default" ? discount?.value : "",
      isMultiline: false,
      isAvailable: true,
    },
    {
      stdDisKey: "discountComment",
      stdDisValue: discount?.discountComment || "",
      isMultiline: true,
      isAvailable: true,
    },
  ]?.filter(({ isAvailable }) => isAvailable);

  const { grossAmount, netDiscount, netAmount } = getDiscountPrices({
    dayPrice: booking?.rentalPrices?.dayPrice || 0,
    delivery: booking?.delivery,
    discountKey: booking?.rentalPrices?.discountList?.[0]?.key,
    discountValue: booking?.rentalPrices?.discountList?.[0]?.value || 0,
    equipmentsSelected: booking?.equipmentsSelected,
    rentalPrices: booking?.rentalPrices,
    servicesSelected: booking?.servicesSelected,
    surfacePrice: booking?.rentalPrices?.surfacePrice || 0,
    unityPrice: booking?.rentalPrices?.unityPrice || 0,
  });

  const bookingRequirements = user?.configuration?.requirements?.booking || {};
  const requiredCustomerFields = Object.entries(bookingRequirements)
    .filter(([, required]) => required)
    .map(([key]) => key);

  const areRequiredCustomerFieldsFilled = requiredCustomerFields.every(
    (key) => booking?.customer?.[key]?.trim?.()?.length > 0,
  );

  const isBookingValid =
    booking?.rentalPeriod?.length &&
    booking?.rentalPrices?.quantity &&
    areRequiredCustomerFieldsFilled;

  return loading ? null : (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={true}
        onClose={() => handleResetClose()}
      >
        <Box sx={{ backgroundColor: Colors.grey }}>
          <Toolbar>
            <IconButton
              edge="start"
              onClick={() => handleResetClose()}
              aria-label="close"
            >
              <CloseIcon sx={{ color: Colors.white }} />
            </IconButton>
            <Typography variant="h6" color={Colors.white}>
              {role === "addBooking"
                ? Language.addBooking.addMainTitle[state]
                : Language.addBooking.updateMainTitle[state]}
            </Typography>
          </Toolbar>
        </Box>
        <DialogContent>
          {state === "estimate" ? (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={() => handleConvertInContract()}
                style={{
                  display: "flex",
                  backgroundColor: Colors.green,
                  borderRadius: "1vh",
                  padding: "2vh",
                }}
              >
                <Typography style={{ color: Colors.white }}>
                  {Language.addBooking.convertInContract}
                </Typography>
              </Button>
            </div>
          ) : null}
          {steps.map(({ helpers, inputsList, key, name, type }) => (
            <Box key={key} flex={2} padding={5}>
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                sx={{
                  borderBottomWidth: 1,
                  borderBottomColor: Colors.greyShaded,
                  borderBottomStyle: "solid",
                }}
                paddingBottom={2}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6" color={Colors.grayText}>
                    {`${helpers}`}
                  </Typography>
                </Box>
                {key === "customer" ? (
                  <Box
                    onClick={() => setIsCustomerSearchOpen(true)}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <SearchIcon
                      sx={{ color: Colors.green, cursor: "pointer" }}
                    />
                    <Typography
                      sx={{
                        color: Colors.green,
                        cursor: "pointer",
                      }}
                    >
                      Rechercher
                    </Typography>
                  </Box>
                ) : null}
              </Box>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                {type === "text" ? (
                  inputsList.map((input) => {
                    const isRequired = requiredCustomerFields.includes(
                      input.key,
                    );
                    const fieldValue = booking?.[key]?.[input.key] ?? "";
                    const hasError = isRequired && !fieldValue?.trim?.();
                    return (
                      <Box padding={1} key={input.key}>
                        <TextField
                          size="small"
                          id={input.key}
                          placeholder={input.label}
                          label={isRequired ? `${input.label} *` : input.label}
                          required={isRequired}
                          error={hasError}
                          helperText={
                            hasError
                              ? Language.addBooking.requiredField
                              : undefined
                          }
                          value={fieldValue}
                          onChange={({ target }) =>
                            handleInputChange({
                              bookingKey: key,
                              target,
                              key: input.key,
                            })
                          }
                        />
                      </Box>
                    );
                  })
                ) : type === "calendar" ? (
                  <Box
                    sx={{
                      padding: 5,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <LokaDatePicker
                      availableEndDate={availableEndDate}
                      availableStartDate={availableStartDate}
                      excludeDates={_excludeDates}
                      isEditable={true}
                      rentalPeriod={booking.rentalPeriod}
                      setRentalPeriod={(rentalPeriod) =>
                        handleChangeDate(rentalPeriod)
                      }
                    />
                  </Box>
                ) : type === "rentalPrices" ? (
                  <div style={{ flex: 1 }}>
                    <div style={{ flex: 1, display: "flex" }}>
                      <div style={{ flex: 1, display: "flex" }}>
                        {_rentMode?.map(({ key, label, isDisabled }) => {
                          const isActive = booking?.rentalPrices?.key === key;
                          const containerStyle = isActive
                            ? {
                                borderBottomColor: Colors.green,
                                borderBottomStyle: "solid",
                                borderBottomWidth: 2,
                                cursor: isDisabled ? "not-allowed" : "pointer",
                              }
                            : {
                                cursor: isDisabled ? "not-allowed" : "pointer",
                              };
                          const textStyle = {
                            color: isActive ? Colors?.green : Colors.greyShaded,
                          };
                          return (
                            <div
                              key={key}
                              onClick={() =>
                                !isDisabled
                                  ? handleRentModeChange({ key })
                                  : null
                              }
                              style={{
                                flex: 1,
                                padding: 5,
                                ...containerStyle,
                              }}
                            >
                              <p style={{ textAlign: "center", ...textStyle }}>
                                {label}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                      <div style={{ flex: 2 }}></div>
                    </div>
                    <div
                      style={{ flex: 1, display: "flex", flexDirection: "row" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          flex: 1,
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <InputLabel
                            variant="standard"
                            htmlFor="rentalPricesSelectInput"
                          >
                            Type de contrat
                          </InputLabel>
                          <Select
                            id="rentalPricesSelectInput"
                            size="small"
                            defaultValue="placeholder"
                            value={rentalPrices?.contractType}
                            onChange={handleChangeContractType}
                            sx={{ flex: 1 }}
                          >
                            <MenuItem
                              disabled
                              key="placeholder"
                              value="placeholder"
                            >
                              {Language.addBooking.selectRentMode}
                            </MenuItem>
                            {discountGrid.map(
                              ({ key: contractTypeKey, label }) => (
                                <MenuItem
                                  key={contractTypeKey}
                                  value={contractTypeKey}
                                >
                                  {label}
                                </MenuItem>
                              ),
                            )}
                          </Select>
                        </div>
                      </div>
                      {rentalPrices?.key && (
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            padding: 20,
                            justifyContent: "center",
                          }}
                        >
                          <TextField
                            type="number"
                            size="small"
                            id="rentalPrice"
                            label={
                              Language.addBooking[`${rentalPrices.key}Label`]
                            }
                            sx={{ width: "100%", marginTop: 1 }}
                            value={rentalPrices[rentalPrices.key]}
                            onChange={({ target }) =>
                              setBooking({
                                ...booking,
                                rentalPrices: {
                                  ...booking.rentalPrices,
                                  [rentalPrices.key]: target.value,
                                },
                              })
                            }
                          />
                          <TextField
                            type="number"
                            size="small"
                            id="rentalPriceQuantity"
                            label={
                              Language.addBooking[`${rentalPrices.key}Quantity`]
                            }
                            sx={{ width: "100%", marginTop: 1 }}
                            value={rentalPrices.quantity}
                            onChange={({ target }) =>
                              setBooking({
                                ...booking,
                                rentalPrices: {
                                  ...rentalPrices,
                                  quantity: target.value,
                                },
                              })
                            }
                          />
                        </div>
                      )}
                      {/* Dedicated section for discount edition */}
                      <div
                        style={{
                          flex: 1,
                          padding: 20,
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <div>
                          {isEditMode ? (
                            <Dialog
                              maxWidth="sm"
                              open={true}
                              onClose={() => handleCloseDiscount()}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 10,
                                  padding: 20,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    paddingBottom: 2,
                                    marginBottom: 2,
                                    borderBottomColor: Colors.greyShaded,
                                    borderBottomWidth: 1,
                                    borderBottomStyle: "solid",
                                  }}
                                >
                                  <p>Ajouter une remise</p>
                                  <p
                                    onClick={() => handleCloseDiscount()}
                                    style={{ cursor: "pointer" }}
                                  >
                                    X
                                  </p>
                                </div>
                                {standardGrid?.map(
                                  ({
                                    isMultiline,
                                    stdGridLabel,
                                    stdDisKey,
                                    stdDisValue,
                                  }) => (
                                    <TextField
                                      multiline={isMultiline}
                                      minRows={isMultiline ? 4 : 1}
                                      type="number"
                                      key={stdDisKey}
                                      size="small"
                                      id={`input_${stdDisKey}`}
                                      label={stdGridLabel}
                                      sx={{ width: "100%", marginTop: 1 }}
                                      value={stdDisValue}
                                      onChange={({ target }) =>
                                        stdDisKey === "discountComment"
                                          ? setDiscount({
                                              ...discount,
                                              [stdDisKey]: target?.value,
                                            })
                                          : setDiscount({
                                              key: stdDisKey,
                                              value: target?.value,
                                              discountComment:
                                                discount?.discountComment || "",
                                            })
                                      }
                                    />
                                  ),
                                )}
                                <div
                                  style={{
                                    alignSelf: "center",
                                    backgroundColor: Colors.green,
                                    padding: 5,
                                    borderRadius: 5,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleSetDiscount()}
                                >
                                  <p
                                    style={{
                                      textAlign: "center",
                                      color: Colors.white,
                                    }}
                                  >
                                    Valider
                                  </p>
                                </div>
                              </div>
                            </Dialog>
                          ) : canSetDiscount ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <p
                                style={{
                                  color: Colors.grayText,
                                  textAlign: "center",
                                }}
                              >
                                {["unity"].includes(discountKey)
                                  ? `${discountValue} ${machineUnity}(s) offert(es)`
                                  : discountValue
                                    ? `${discountValue} ${Language?.addBooking?.discountLabels?.[discountKey]} offert(s)`
                                    : `Aucune remise appliquée`}
                              </p>
                              <ModeEditIcon
                                sx={{ color: Colors.green, cursor: "pointer" }}
                                onClick={() => handleSwitchOnEditMode()}
                              />
                            </div>
                          ) : (
                            <div>
                              <p
                                style={{
                                  color: Colors.greyShaded,
                                  textAlign: "center",
                                  flexWrap: "wrap",
                                }}
                              >{`Aucune remise ne peut être appliquée sur ce type de contrat.`}</p>
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          padding: 20,
                          justifyContent: "center",
                          alignItems: "flex-end",
                          gap: 5,
                        }}
                      >
                        {[
                          {
                            label: "Montant brut",
                            key: "grossAmount",
                            textStyle: {
                              color: Colors.greyShaded,
                              fontStyle: "normal",
                            },
                            value: grossAmount,
                          },
                          {
                            label: "Remise",
                            key: "netDiscount",
                            textStyle: {
                              color: Colors.greyShaded,
                              fontStyle: "normal",
                              fontSize: 12,
                              width: "80%",
                              textAlign: "right",
                              borderBottomColor: Colors.greyHighShaded,
                              borderBottomStyle: "solid",
                              borderBottomWidth: 1,
                            },
                            value: netDiscount,
                          },
                          {
                            label: "Montant net",
                            key: "netAmount",
                            textStyle: {
                              color: Colors.grayText,
                              fontWeight: "bold",
                            },
                            value: netAmount,
                          },
                        ].map(({ label, key, textStyle, value }) => (
                          <Typography
                            key={key}
                            style={textStyle}
                          >{`${label} : ${value || 0}€ HT`}</Typography>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : type === "switchServices" ? (
                  inputsList?.length ? (
                    inputsList.map((input) => (
                      <Box sx={{ padding: 1 }} key={input.key}>
                        <FormControlLabel
                          control={
                            <Switch
                              color="secondary"
                              checked={!booking?.[key]?.[input.key] === false}
                              onChange={() =>
                                handleSwitchServicesChange({
                                  group: key,
                                  key: input.key,
                                  value: input.value,
                                })
                              }
                            />
                          }
                          label={`${input.label} (${input.value} ${input.sigle})`}
                        ></FormControlLabel>
                      </Box>
                    ))
                  ) : (
                    <Box>
                      <Typography
                        sx={{ color: Colors.greyShaded, fontStyle: "italic" }}
                      >
                        {Language.addBooking?.noServicesForThisMachine}
                      </Typography>
                    </Box>
                  )
                ) : type === "switchDiscount" ? (
                  inputsList?.length ? (
                    inputsList.map((input) => (
                      <Box sx={{ padding: 1 }} key={input.key}>
                        <FormControlLabel
                          control={
                            <Switch
                              color="secondary"
                              checked={
                                booking.rentalPrices?.contractType === input.key
                              }
                              onChange={() =>
                                handleSwitchDiscountChange({
                                  key: input.key,
                                })
                              }
                            />
                          }
                          label={`${input.label}`}
                        ></FormControlLabel>
                      </Box>
                    ))
                  ) : (
                    <Box>
                      <Typography
                        sx={{ color: Colors.greyShaded, fontStyle: "italic" }}
                      >
                        {Language.addBooking?.noServicesForThisMachine}
                      </Typography>
                    </Box>
                  )
                ) : type === "switchEquipments" ? (
                  inputsList?.length ? (
                    inputsList.map((input) => (
                      <Box sx={{ padding: 1 }} key={input.key}>
                        <FormControlLabel
                          control={
                            <Switch
                              color="secondary"
                              checked={!booking[key]?.[input.key] === false}
                              onChange={() =>
                                handleSwitchEquipmentsChange({
                                  group: key,
                                  key: input.key,
                                  value: input.value,
                                })
                              }
                            />
                          }
                          label={`${input.label} (${input.value || "0"} ${
                            input.sigle
                          })`}
                        ></FormControlLabel>
                      </Box>
                    ))
                  ) : (
                    <Box>
                      <Typography
                        sx={{ color: Colors.greyShaded, fontStyle: "italic" }}
                      >
                        {Language.addBooking?.noEquipmentsForThisMachine}
                      </Typography>
                    </Box>
                  )
                ) : type === "multiline" ? (
                  <>
                    <Box padding={1} width="80%">
                      <TextField
                        style={{ width: "100%" }}
                        multiline
                        rows={4}
                        size="small"
                        id={key}
                        label={name}
                        value={booking?.[key]?.text}
                        onChange={({ target }) =>
                          handleInputChange({
                            bookingKey: key,
                            target,
                            key: "text",
                          })
                        }
                      />
                    </Box>
                    <Box padding={1} width="80%">
                      <TextField
                        style={{ width: "100%" }}
                        size="small"
                        id="repairOrderNumber"
                        label="N° d'OR"
                        value={booking?.repairOrderNumber ?? ""}
                        onChange={({ target }) =>
                          handleInputChange({
                            target,
                            key: "repairOrderNumber",
                          })
                        }
                      />
                    </Box>
                  </>
                ) : type === "bookingCosts" ? (
                  <Box padding={1} width="80%">
                    <MultipleDesignationInput
                      inputList={booking?.bookingCosts}
                      onChange={(bookingCosts) =>
                        setBooking({ ...booking, bookingCosts })
                      }
                    />
                  </Box>
                ) : type === "subCompany" ? (
                  <Box
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {subCompanies?.map(({ name }) => (
                      <Box
                        key={name}
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 10,
                          borderRadius: 15,
                          backgroundColor:
                            name === booking?.subCompany?.name
                              ? Colors.green
                              : Colors.greyVeryHighShaded,
                          padding: 15,
                          margin: 15,
                        }}
                      >
                        <Radio
                          checked={name === booking?.subCompany?.name}
                          onChange={({ target }) =>
                            handleSetSubCompany({ cieName: target?.value })
                          }
                          value={name}
                          name="radio-buttons"
                          inputProps={{ "aria-label": name }}
                          style={{
                            color:
                              name === booking?.subCompany?.name
                                ? Colors.white
                                : Colors.greyShaded,
                          }}
                        />
                        <div>
                          <Typography
                            style={{
                              color:
                                name === booking?.subCompany?.name
                                  ? Colors.white
                                  : Colors.greyShaded,
                            }}
                          >
                            {`${name}`}
                          </Typography>
                        </div>
                      </Box>
                    ))}
                    {subCompanies?.length === 1 ? (
                      <Box style={{ flex: 1 }}></Box>
                    ) : null}
                  </Box>
                ) : type === "validation" ? (
                  <Box sx={{ padding: 1 }}>
                    <Summary />
                  </Box>
                ) : null}
              </Box>
            </Box>
          ))}
          <Box
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              justifyContent: "space-between",
            }}
            padding={5}
          >
            {[
              {
                helpers: "9. Etat des lieux",
                key: "checker",
                name: "Etat des lieux",
              },
              {
                helpers: "10. Livraison",
                key: "delivery",
                name: "Livraison",
              },
            ].map(({ helpers, key, name }, index) => (
              <div
                key={key}
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                    borderBottomWidth: 1,
                    borderBottomColor: Colors.greyShaded,
                    borderBottomStyle: "solid",
                  }}
                  paddingBottom={2}
                >
                  <Typography variant="h6" color={Colors.green}>
                    {`${helpers}`}
                  </Typography>
                </Box>
                {index === 0 ? (
                  <Box sx={{ flex: 1 }}>
                    <FormControl sx={{ minWidth: 200 }}>
                      <InputLabel>Checker</InputLabel>
                      <Select
                        style={{ flex: 1 }}
                        value={checker}
                        onChange={({ target }) =>
                          handleSelectChange({
                            key: "checker",
                            value: target.value,
                          })
                        }
                      >
                        <MenuItem
                          disabled
                          key="placeholder"
                          value="placeholder"
                        >
                          {Language.addBooking.selectChecker}
                        </MenuItem>
                        {members?.map(({ firstName, id, lastName }) => (
                          <MenuItem key={id} value={id}>
                            {`${firstName} ${lastName}`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                ) : (
                  <Box sx={{ flex: 1 }}>
                    <FormControl sx={{ minWidth: 200 }}>
                      <InputLabel>Agence de départ</InputLabel>
                      <Select
                        style={{ flex: 1 }}
                        value={departureAgency}
                        onChange={({ target }) =>
                          handleSelectChange({
                            key: "departureAgency",
                            value: target.value,
                          })
                        }
                      >
                        <MenuItem
                          disabled
                          key="placeholder"
                          value="placeholder"
                        >
                          {Language.addBooking.selectAgency}
                        </MenuItem>
                        {cieAgencies
                          ?.map(({ name }) => name)
                          .sort()
                          .map((agency) => (
                            <MenuItem key={agency} value={agency}>
                              {agency}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Box>
                )}
              </div>
            ))}
          </Box>

          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-around"
            flex={1}
          >
            <Button
              disabled={!isBookingValid}
              onClick={() => handleCreateUpdateBooking()}
              sx={{
                backgroundColor: Colors.green,
                color: Colors.white,
              }}
            >
              {Language.addBooking[role].toUpperCase()}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={isCustomerSearchOpen}
        onClose={() => setIsCustomerSearchOpen()}
      >
        <Box sx={{ padding: "2vh" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1vh",
            }}
          >
            <TextField
              onChange={({ target }) =>
                handleInputChange({
                  bookingKey: "customer",
                  key: "name",
                  target,
                })
              }
              placeholder="Nom du client"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment>
                      <SearchIcon />
                    </InputAdornment>
                  ),
                },
              }}
              value={booking?.customer?.name}
            ></TextField>
            <Button
              sx={{ backgroundColor: Colors.green }}
              onClick={() => handleGetCustomers()}
            >
              <Typography sx={{ color: Colors.white }}>Rechercher</Typography>
            </Button>
          </Box>
          <Divider sx={{ margin: "1vh" }} />
          <List>
            {suggestedCustomers?.length > 0 ? (
              suggestedCustomers?.map(({ city, name, ...rest }, index) => (
                <ListItem key={index}>
                  <ListItemButton
                    onClick={() =>
                      handleSelectCustomer({ city, name, ...rest })
                    }
                  >
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={[name, city]?.filter((el) => el)?.join(" | ")}
                    />
                  </ListItemButton>
                </ListItem>
              ))
            ) : (
              <Typography
                sx={{
                  textAlign: "center",
                  color: Colors.greyShaded,
                  margin: "1vh",
                  fontStyle: "italic",
                }}
              >
                Saisissez le nom de votre client puis cliquer sur Rechercher
              </Typography>
            )}
          </List>
        </Box>
      </Dialog>
      <LokaActivityIndicator />
    </>
  );
};

export default AddBooking;
